module.exports = __webpack_public_path__ + "static/img/5.11053a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/5.png
// module id = 2Pfm
// module chunks = 13